import angular from 'angular'

import UserDetailsForm from './user-details-form'
import UserCard        from './user-card'

let module = angular.module('myProfileComponentsModule', [
  UserDetailsForm,
  UserCard
])
.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/profile/my-profile/components/index.js